@if(componentModel.packages.value.length){
    <div class="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        @for(membership of componentModel.packages.value; track $index){
            <div class="{{ $index === 1? 'rounded-3xl bg-white/5 p-8 ring-2 ring-primary xl:p-10': 'rounded-3xl p-8 ring-1 ring-white/10 xl:p-10'}}">
                <div class="flex items-center justify-between gap-x-4">
                    <h2 id="tier-freelancer" class="text-lg font-semibold leading-8 text-normal">{{ membership?.title?.value | translate}}</h2>
                </div>
                <p class="mt-4 text-sm leading-6 text-gray-300">
                    {{ membership?.description?.value | translate}}
                </p>
                <p class="mt-6 flex items-baseline gap-x-1">
                    <span class="text-4xl font-bold tracking-tight text-normal"> {{membership?.price?.value}}</span>
                </p>
                <a [href]="membership?.buttonLink?.value" target="_blank" aria-describedby="tier-freelancer" class="mt-6 block rounded-md bg-white/10 px-3 py-2 text-center text-sm font-semibold leading-6 text-normal hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
                    {{membership?.buttonText?.value}}
                </a>
                <ul role="list" class="mt-8 space-y-3 text-sm leading-6 text-gray-300 xl:mt-10">
                    <li *ngFor="let option of membership?.allowedOptions?.value" class="flex gap-x-3">
                        <svg class="h-6 w-5 flex-none text-normal" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                        </svg>
                        {{ option.option.value | translate}}
                    </li>
                </ul>
            </div>
        }


    </div>
}

